import React, { useState, useEffect } from 'react';
import {
    Layout,
    Select,
    Input,
    Button,
    Form,
    message,
} from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const { Content } = Layout;
const { Option } = Select;
axios.defaults.baseURL = 'https://cybersphereinstitute.xyz';
// axios.defaults.baseURL = 'http://45.250.253.84:30003';

const CreateProject = () => {
    const navigate = useNavigate();
    const [walletGroups, setWalletGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [chains, setChains] = useState([]);  // 新增：存储链的列表
    const [selectedChain, setSelectedChain] = useState(null);  // 新增：选中的链
    const [selectedGroup, setSelectedGroup] = useState(null); // 选择的钱包组
    const [walletAddresses, setWalletAddresses] = useState([]); // 用于存储钱包地址列表
    const [mode, setMode] = useState('create'); // 'create' or 'import'

    useEffect(() => {
        // 在 walletGroups 非空时，默认选择第一个钱包组
        if (walletGroups.length > 0 && !selectedGroup) {
            setSelectedGroup(walletGroups[0].group_id);
            form.setFieldsValue({ create_group_id: walletGroups[0].group_id }); // 更新表单值
            console.log(selectedGroup);
        }
    }, [walletGroups]);

    useEffect(() => {
        fetchWalletGroups();
        fetchChains(); // 获取链的列表
        // if (walletGroups.length > 0) {
        //     setSelectedGroup(walletGroups[0].group_id);
        //     console.log(selectedGroup);
        // }
    }, []);

    useEffect(() => {
        // 监听 selectedGroup，当钱包组选择变化时请求钱包组信息
        if (selectedGroup) {
            fetchWalletInfo(selectedGroup);
        }
    }, [selectedGroup]);

    const fetchChains = async () => {
        try {
            const response = await axios.get('/api/v1/chain/list');
            if (response.data.code === 0) {
                setChains(Object.values(response.data.data));  // 提取链的列表
            } else {
                message.error(response.data.msg);
            }
        } catch(error) {
            message.error(error);
        }
    };

    const fetchWalletGroups = async (name = '') => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/wallet/list', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { name, page: 1, size: 999 },
            });
            console.log(response.data);
            if (response.data.code === 0) {
                setWalletGroups(response.data.data.items);

                // setSelectedGroup(response.data.data.items[0].group_id);
                // console.log(response.data.data.items[0].group_id);
            } else {
                if(response.data.code === -5) {
                    console.log("token 过期")
                    message.error('token 过期');
                    navigate('/login');
                } else {
                    message.error(response.data.msg);
                }
            }
        } catch(error) {
            message.error(error);
        }
    };

    const fetchWalletInfo = async (group_id) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/wallet/info', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { group_id, page: 1, size: 1 }, // 获取一个钱包地址
            });

            if (response.data.code === 0) {
                const { items } = response.data.data;
                if (items && items.length > 0) {
                    // 将第一个钱包地址填充到创建钱包地址输入框
                    form.setFieldsValue({ create_address: items[0].address });
                    setWalletAddresses(items); // 存储钱包地址列表
                }
            } else {
                message.error(response.data.msg);
            }
        } catch (error) {
            message.error('无法获取钱包信息');
        }
    };

    const fetchTokenInfo = async () => {
        try {
            const values = form.getFieldsValue();
            const token = localStorage.getItem('token');
            if (!values.token_address || !values.chain_id) return;

            const response = await axios.get('/api/v1/projects/import/info', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    token_address: values.token_address,
                    chain_id: values.chain_id,
                    chain_type: "EVM",
                }
            });

            if (response.data.code === 0) {
                const { token_name, symbol, decimals, total_supply } = response.data.data;
                form.setFieldsValue({
                    token_name,
                    symbol,
                    decimals,
                    total_supply,
                });
            } else {
                message.error(response.data.msg);
            }
        } catch (error) {
            message.error('获取代币信息失败');
        }
    };

    // 导入项目
    const importProject = async (values) => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const payload = {
                ...values,
                total_supply: String(values.total_supply),
                chain_type: "EVM"
            };

            const response = await axios.post('/api/v1/projects/import', payload, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data.code === 0) {
                message.success(`项目导入成功: ${response.data.data.scan_url}`);
            } else {
                message.error(response.data.msg);
            }
        } catch (error) {
            message.error('导入项目失败');
        } finally {
            setLoading(false);
        }
    };


    const createProject = async (values) => {
        console.log("aaa");
        setLoading(true);
        const token = localStorage.getItem('token');
        const payload = {
            token_name: values.token_name,
            symbol: values.symbol,
            total_supply: parseInt(values.total_supply) || 1000000000, // 默认1Billion
            decimals: parseInt(values.decimals, 10) || 18, // 默认18
            create_group_id: values.create_group_id,
            create_address: values.create_address,
            project_name: values.project_name,
            chain_type: "evm", // 默认使用EVM链类
            chain_id: selectedChain?.chain_id || null, // 使用选中的链ID
            has_whitelist: values.has_whitelist, // ✅ 传递白名单参数
        };

        try {
            const response = await axios.post('/api/v1/projects/create', payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
            if (response.data.code === 0) {
                // alert('项目创建成功' + ',token_address: ' + response.data.data.token_address + "\n tx_hash: " + response.data.data.tx_hash);
                // 可选择在这里清空表单或者跳转到项目详情页

                const { token_address, tx_hash } = response.data.data;
                const successMessage = `项目创建成功\nToken Address: ${token_address}\nTx Hash: ${tx_hash}`;

                if (window.confirm(successMessage + "\n\n点击确定复制信息")) {
                    navigator.clipboard.writeText(successMessage)
                        .then(() => message.success('信息已复制到剪贴板'))
                        .catch((err) => message.error(`复制失败: ${err.message}`));
                }

            } else {
                handleError(response.data.code, response.data.msg);
            }
        } catch(error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    // 处理错误码
    const handleError = (code, msg) => {
        switch (code) {
            case 4001:
                message.error('代币名称已存在');
                break;
            case 4002:
                message.error('创建失败');
                break;
            case 4003:
                message.error('项目组名称已存在');
                break;
            default:
                message.destroy();
                message.error(msg);
                break;
        }
    };

    return (
        <Content style={{ padding: '20px' }}>
            <Form
                form={form}
                layout="vertical"
                onFinish={mode === 'create' ? createProject : importProject}
                style={{ maxWidth: 600, margin: '0 auto' }}
            >
                {/* 选择创建项目或导入项目 */}
                <Form.Item name="mode" label="操作类型">
                    <Select value={mode} onChange={setMode}>
                        <Option value="create">创建项目</Option>
                        <Option value="import">导入项目</Option>
                    </Select>
                </Form.Item>

                {/* 项目名 */}
                <Form.Item
                    name="project_name"
                    label="项目名"
                    rules={[{ required: true, message: '请输入项目名' }]}
                >
                    <Input placeholder="请输入项目名" />
                </Form.Item>

                {/* 导入模式需要填写的字段 */}
                {mode === 'import' && (
                    <>
                        {/* 代币地址 */}
                        <Form.Item
                            name="token_address"
                            label="代币地址"
                            rules={[{ required: true, message: '请输入代币地址' }]}
                        >
                            <Input placeholder="请输入代币地址" onBlur={fetchTokenInfo} />
                        </Form.Item>

                        {/* 选择链 */}
                        {/*<Form.Item*/}
                        {/*    name="chain_id"*/}
                        {/*    label="链"*/}
                        {/*    rules={[{ required: true, message: '请选择链' }]}*/}
                        {/*>*/}
                        {/*    <Select*/}
                        {/*        allowClear*/}
                        {/*        placeholder="选择链"*/}
                        {/*        onChange={(value) => {*/}
                        {/*            setSelectedChain(chains.find(chain => chain.chain_id === value));*/}
                        {/*            fetchTokenInfo();*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        {chains.map((chain) => (*/}
                        {/*            <Option key={chain.chain_id} value={chain.chain_id}>*/}
                        {/*                {chain.chain_name}*/}
                        {/*            </Option>*/}
                        {/*        ))}*/}
                        {/*    </Select>*/}
                        {/*</Form.Item>*/}

                    </>
                )}

                {/* 代币信息（仅导入模式会自动填充） */}
                <Form.Item
                    name="token_name"
                    label="代币名"
                    rules={[{ required: true, message: '请输入代币名' }]}
                >
                    <Input placeholder="请输入代币名" disabled={mode === 'import'} />
                </Form.Item>

                <Form.Item
                    name="symbol"
                    label="代币符号"
                    rules={[{ required: true, message: '请输入代币符号' }]}
                >
                    <Input placeholder="请输入代币符号" disabled={mode === 'import'} />
                </Form.Item>

                <Form.Item
                    name="total_supply"
                    label="总供应量"
                    initialValue={1000000000}
                    rules={[{ required: true, message: '请输入总供应量' },
                        {
                            type: 'number',
                            validator: (_, value) =>
                                value > 0
                                    ? Promise.resolve()
                                    : Promise.reject(new Error('总供应量必须大于0')),
                        },
                    ]}
                >
                    <Input placeholder="请输入总供应量" type="number" disabled={mode === 'import'} />
                </Form.Item>

                <Form.Item
                    name="decimals"
                    label="精度"
                    initialValue={18}  // 设置默认值为 18
                    rules={[{ required: false, message: '请输入精度' },
                        {
                            type: 'number',
                            validator: (_, value) =>
                                value > 0
                                    ? Promise.resolve()
                                    : Promise.reject(new Error('精度必须大于0')),
                        },
                    ]}
                >
                    <Input placeholder="请输入精度" type="number" disabled={mode === 'import'} />
                </Form.Item>

                {/* 关联钱包组 */}
                <Form.Item
                    name="create_group_id"
                    label="关联钱包组"
                    rules={[{ required: true, message: '请选择钱包组' }]}
                >
                    <Select
                        allowClear
                        placeholder="选择钱包组"
                        onChange={setSelectedGroup}
                    >
                        {walletGroups.map((group) => (
                            <Option key={group.group_id} value={group.group_id}>
                                {group.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="chain_id"
                    label="链"
                    rules={[{ required: true, message: '请选择链' }]}
                >
                    <Select
                        allowClear
                        placeholder="选择链"
                        value={selectedChain?.chain_id}
                        onChange={(value) => setSelectedChain(chains.find(chain => chain.chain_id === value))}
                        style={{ width: '100%' }}
                    >
                        {chains.map((chain) => (
                            <Option key={chain.chain_id} value={chain.chain_id}>
                                {chain.chain_name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                {/* 创建钱包地址 */}
                <Form.Item
                    name="create_address"
                    label="创建的钱包地址"
                    rules={[{ required: true, message: '请输入创建的钱包地址' }]}
                >
                    <Input placeholder="请输入创建的钱包地址" />
                </Form.Item>

                {mode === 'create' && (
                    <>
                <Form.Item name="has_whitelist" label="是否开启白名单" rules={[{ required: true, message: '请选择是否开启白名单' }]}>
                    <Select placeholder="请选择">
                        <Option value={1}>开启</Option>
                        <Option value={2}>不开启</Option>
                    </Select>
                </Form.Item>
                    </>
                )}

                {/* 提交按钮 */}
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                        {mode === 'create' ? '创建项目' : '导入项目'}
                    </Button>
                </Form.Item>
            </Form>
        </Content>
    );
};

export default CreateProject;
